import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-section',
  imports: [TranslatePipe],
  templateUrl: './onyx-section.component.html',
  styleUrl: './onyx-section.component.scss',
  host: {
    '[style.gap.px]': `gap()`,
    '[style.padding.px]': `padding()`,
  },
})
export class OnyxSectionComponent {
  public readonly heading = input.required<string>();
  public readonly count = input<number>();
  public readonly justify = input<'left' | 'right'>('left');
  public readonly identifierColor = input<OnyxColor | null>();
  public readonly gap = input(16);
  public readonly padding = input(16);
  public readonly titleGap = input(12);
}
